import { render, staticRenderFns } from "./CustomerSupportUserList.vue?vue&type=template&id=634499e6&"
import script from "./CustomerSupportUserList.vue?vue&type=script&lang=js&"
export * from "./CustomerSupportUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports